module.exports = __webpack_public_path__ + "static/img/case.7f5ba011.png";